import { useLocation } from "react-router-dom";
import { useAuth } from "../../App";
import { WorkspaceNavigation } from "./WorkspaceNavigation";
import { adminNavigation } from "./navigationGroups";

export const AdminNavigation = () => {
  const { user } = useAuth();
  const location = useLocation();
  if (!user?.is_admin) return null;
  return (
    <div className="admin-workspace-navigation">
      <WorkspaceNavigation groups={adminNavigation} pathname={location.pathname} scope="admin-workspace" title="Administration" />
    </div>
  );
};